module.exports = __webpack_public_path__ + "src/assets/games/42/26.jpg";